<template>
    <div>
        <!-- 轮播图 -->
        <div class="slide-box">
            <Slide/>
        </div>
        <!-- 轮播图 -->

        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('technologySolutions.title')}}
                <hr>
            </span>
        </h1>
        <div class="row">
            <p>{{$t('technologySolutions.introText')}}</p>
        </div>
        <div class="row te-row">
            <ul class="pic-list tec-list">
                <li v-for="(item,index) in technologySolutionsList[$i18n.locale]" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <h1>{{item.title}}</h1>
                    <p>{{item.text}}</p>
                    <router-link :to="item.toLink" class="btn-list">{{$t('common.learnMore')}}</router-link>
                </li>
            </ul>
        </div>

        <!-- TEAMS -->
        <div class="teams-row">
            <div class="row">
                <h1>{{$t('common.trustedBy')}}</h1>
                <ul class="teams-img-list">
                    <li v-for="(item,index) in teamsImg" :key="index">
                        <img class="img-responsive" :src="item.url" alt="">
                    </li>
                </ul>
            </div>
        </div>

        <!-- title -->
        <!-- <h1 class="main-title">
            <span>
                CASE STUDIES
            </span>
        </h1>
        <div class="row">
            <p>m semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet </p>
        </div>

        <div class="row te-row">
            <ul class="pic-list">
                <li v-for="(item,index) in caseList" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <h1>{{item.title}}</h1>
                    <p>{{item.text}}</p>
                    <router-link to="" class="btn-list">Learn More</router-link>
                </li>
            </ul>
        </div> -->
    </div>
</template>

<script>
    import Slide from '../../components/Slide/Slide'
    export default {
        data() {
           return {
               technologySolutionsList:'',
            //    caseList:'',
               teamsImg:[
                    {url:require('../../assets/images/ProgressMark_logo.png')},
                    {url:require('../../assets/images/sony_logo_black.png')},
                    {url:require('../../assets/images/Nvidia-logo_black.png')},
                    {url:require('../../assets/images/Dell_logo_black.png')},
                    {url:require('../../assets/images/inter_logo_black.png')},
                    {url:require('../../assets/images/lenovo-logo-black.png')},
                    {url:require('../../assets/images/asus-logo-black.png')}
                ]
           }
        },
        components:{
            Slide
        },
        methods:{
            getTechnologySolutionsList () {
                this.$api.tecsolutions.tecsolutionsList().then(res=>{
                    this.technologySolutionsList = res.data.result
                    console.log(res.data.result)
                }).catch(
                    (error) => {
                        console.log(error)
                    }
                )
            },
            // getCaseList(){
            //     this.$api.caselist.caseList().then(res=>{
            //         this.caseList = res.data.result
            //     }).catch(
            //         (error) => {
            //             console.log(error)
            //         }
            //     )
            // }
        },
        mounted(){
            this.getTechnologySolutionsList();
            // this.getCaseList()
        }
    }
</script>

<style scoped>
   .teams-row{
        width:100%;
        background:#fff;
    }
    .teams-row .row{
        margin-top: 0;
        margin-bottom: 0;
    }
    .teams-row h1{
        font-size: 2rem;
        font-weight: 700;
        margin:4rem 0;
    }
    .teams-row ul{
        margin-bottom: 4rem;
        display: table;
    }
    .teams-row ul li{
        display: table-cell;
        text-align: center;
        width: 1%;
        padding: 1rem;
    }
    .teams-row ul li img{
        max-width:100%;
        height: auto;
    }
    .tec-list li p{
        min-height: 6rem;
    }
    @media (max-width: 767px){
        .teams-row h1{
            font-size: 1.2rem;
            margin:1rem 0;
        }
        .teams-row ul{
            margin-bottom: 1rem;
        }
        .teams-row ul li{
            padding:0.2rem
        }
        .tec-list li p{
            min-height: auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Technology/TechnologySolutions.vue